// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { ssoSamlAssertionContentGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    connectorId: z.string().min(1).max(128),
    assertionContent: ssoSamlAssertionContentGuard.optional(),
    createdAt: z.number().optional(),
    expiresAt: z.number(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    connectorId: z.string().min(1).max(128),
    assertionContent: ssoSamlAssertionContentGuard,
    createdAt: z.number(),
    expiresAt: z.number(),
});
export const IdpInitiatedSamlSsoSessions = Object.freeze({
    table: 'idp_initiated_saml_sso_sessions',
    tableSingular: 'idp_initiated_saml_sso_session',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        connectorId: 'connector_id',
        assertionContent: 'assertion_content',
        createdAt: 'created_at',
        expiresAt: 'expires_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'connectorId',
        'assertionContent',
        'createdAt',
        'expiresAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
